import React from "react";
var styles = {
  msgBox: {
    zIndex: 1,
    borderWidth: 6,
    paddingTop: 10,
    marginBottom: 10,
    marginTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 10,
    borderStyle: 'dashed'
  },
  msgBoxError: {
    borderColor: '#fd5353',
    backgroundColor: '#f3e58f'
  }
};
export default function ErrorMessage(_ref) {
  var debug = _ref.debug,
    error = _ref.error,
    module = _ref.module;
  try {
    if (debug && !!error) {
      var message = "".concat(module.title, " id: ").concat(module.id, " Render Error\n").concat(error, "\n ").concat(error.stack);
      return /*#__PURE__*/React.createElement("div", {
        style: styles.msgBox
      }, /*#__PURE__*/React.createElement("p", {
        style: styles.msgBoxError
      }, message));
    }
  } catch (e) {
    // do nothing
  }
  return null;
}